import { useState } from "react";

// Primary: SPOThQ cryptocurrency-icons (SVG) via jsdelivr — has btc, eth, ada, doge, sol, avax, matic, near
// Fallback CDN: coincap icons (PNG) — has TON and others
// Final fallback: styled ticker badge

const PRIMARY_CDN = (symbol) =>
  `https://cdn.jsdelivr.net/npm/cryptocurrency-icons@0.18.1/svg/color/${symbol.toLowerCase()}.svg`;

// Coincap files some assets under their full name rather than ticker.
const FALLBACK_SLUG_OVERRIDES = {
  TON: "toncoin",
};

const FALLBACK_CDN = (symbol) => {
  const slug = FALLBACK_SLUG_OVERRIDES[symbol] || symbol.toLowerCase();
  return `https://assets.coincap.io/assets/icons/${slug}@2x.png`;
};

const BRAND_COLORS = {
  BTC: "#F7931A",
  ETH: "#627EEA",
  ADA: "#0033AD",
  DOGE: "#C2A633",
  SOL: "#9945FF",
  AVAX: "#E84142",
  MATIC: "#8247E5",
  NEAR: "#00C08B",
  TON: "#0098EA",
};

/** <CryptoLogo symbol="BTC" size={28} />
 * Renders the official crypto logo with graceful fallback to a styled ticker badge. */
export default function CryptoLogo({ symbol, size = 24, className = "" }) {
  const [stage, setStage] = useState(0); // 0 = primary, 1 = fallback, 2 = ticker badge
  const color = BRAND_COLORS[symbol] || "#888";
  const dim = { width: size, height: size };

  if (stage === 2) {
    return (
      <div
        className={`inline-flex items-center justify-center rounded-full font-extrabold text-white flex-shrink-0 ${className}`}
        style={{
          ...dim,
          background: color,
          fontSize: size * 0.38,
          fontFamily: "Fredoka",
        }}
        data-testid={`crypto-logo-${symbol}`}
        aria-label={`${symbol} logo`}
      >
        {symbol.slice(0, 3)}
      </div>
    );
  }

  const src = stage === 0 ? PRIMARY_CDN(symbol) : FALLBACK_CDN(symbol);
  return (
    <img
      src={src}
      alt={`${symbol} logo`}
      loading="lazy"
      draggable={false}
      onError={() => setStage((s) => s + 1)}
      data-testid={`crypto-logo-${symbol}`}
      className={`flex-shrink-0 rounded-full ${className}`}
      style={{ ...dim, objectFit: "contain" }}
    />
  );
}
